import { render } from "./StockTransfert.vue?vue&type=template&id=b5b95602"
import script from "./StockTransfert.vue?vue&type=script&lang=js"
export * from "./StockTransfert.vue?vue&type=script&lang=js"

import "./StockTransfert.vue?vue&type=style&index=0&id=b5b95602&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__